import React, { useCallback, useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import { FiFile } from 'react-icons/fi'
import { toast } from 'react-toastify'

import Yup from '~/services/yup'
import { api, authHeaders } from '~/services/api'
import { Container, ButtonContainer } from './styles'
import { Calendar, Button, Select, Textbox } from '~/components/Form'
import rangeDayGif from '~/assets/images/gifs/periodo-dias.gif'
import { forceDownloadFileFromURL } from '~/util/file'
import formUtils from '~/util/form'
import Spinner from '~/components/Spinner'

const nomeRelatorio = 'Relatório de Atividades da Diretoria'

const validation = Yup.object().shape({
    periodo: Yup.string().nullable().required('Informe um periodo para a busca.')
})

export default function () {
    const [assuntos, setAssuntoss] = useState(null)

    async function loadAssuntos() {
        const response = await api.get('visita_diretoria/assunto', authHeaders())

        setAssuntoss(response)
    }

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        try {
            values = formUtils.extractFormValues(values)

            const response = await api.post('visita_diretoria/relatorio', values, authHeaders())

            forceDownloadFileFromURL(response.link, nomeRelatorio)

            resetForm()
        } catch (e) {
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    useEffect(() => {
        loadAssuntos()
    }, [])

    if (!assuntos) {
        return <Spinner />
    }

    return (
        <Container className="animated fadeIn faster form col-span-3">
            <Formik
                initialValues={{ 
                    periodo: '',
                    assunto: null,
                    nome: '',
                    crm: ''
                }}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue, resetForm }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="periodo"
                            label="Período para busca"
                            selectionMode="range"
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Textbox 
                            name="nome"
                            label="Nome do diretor"
                        />

                        <Textbox 
                            name="crm"
                            label="CRM do diretor"
                        />

                        <Select 
                            name="assunto"
                            label="Assunto"
                            options={assuntos.map(assunto => (
                                { label: assunto.descricao, value: assunto.id }
                            ))}
                            onChange={(selected, meta) => {
                                setFieldValue(meta.name, selected)
                            }}
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
